import React from 'react';
import "./ComparatorWebcam.scss";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import pictureCheck from "./images/check.png";
import pictureCrossSmall from "./images/cross-small.png";
import pictureBandeau from "./images/bandeau-01.svg";
import pictureChaturbate from "./images/chaturbate.png";
import pictureVoissa from "./images/Logo_voissa_cam-01.png";
import pictureStripchat from "./images/stripchat.png";
import pictureMyfreecams from "./images/myfreecams.png";
import pictureBongacams from "./images/bongacams.png";
import pictureLiveJasmin from "./images/logo-livejasmin.png";
import qs from "qs";
import {fetchFluxChaturbate, fetchFluxXlovecam} from "../../../libs/api";
import {LoadingBar} from "../../components/Loader";
import {canonical, cropText} from "../../../libs/helper";
import {Link} from "react-router-dom";
import createLink from "../../../libs/createLink";
import CtaCannot from "../../components/CtaCannot";
import {Can} from "../../../ability-context";
import Helmet from "react-helmet";

class ComparatorWebcam extends React.Component {
    constructor(props) {
        super(props);
        let {source = "organic"} = qs.parse(props.location.search, {ignoreQueryPrefix: true});
        /*if(!['tab-mobile', 'tab-desktop', 'organic']){
            source = "organic";
        }*/

        this.source = source;


        this.urlChaturbate = `https://tracker.snaping.net/index.php?key=5mwie2rloi33rnx8ujs0&t=&source=${this.source}&site=voissa&adparameter2=chaturbate`;
        this.urlXlovecam = `https://tracker.snaping.net/index.php?key=5mwie2rloi33rnx8ujs0&t=&source=${this.source}&site=voissa&adparameter2=xlovecam`;
        this.urlStripchat = `https://tracker.snaping.net/index.php?key=5mwie2rloi33rnx8ujs0&t=&source=${this.source}&site=voissa&adparameter2=stripchat`;

        this.urlTracker = "";
        if(this.source === "tab-mobile"){
            this.urlTracker = "https://emstat.fr/hit.php?zone=7ebd489b0ef36f8fd63731325cea9c8e&campaign=475960d297da52adfe2f0d28f2bd0307&format=img";
        }
        else if(this.source === "tab-desktop"){
            this.urlTracker = "https://emstat.fr/hit.php?zone=d8e545b7b207106a65d87e1e56e84a88&campaign=475960d297da52adfe2f0d28f2bd0307&format=img";
        }
        else if(this.source === "organic"){
            this.urlTracker = "https://emstat.fr/hit.php?zone=37f30077656356dee66dd7c036ecde1d&campaign=475960d297da52adfe2f0d28f2bd0307&format=img";
        }
        else{
            this.urlTracker = "https://emstat.fr/hit.php?format=img&zone=01d20d75366a13545af39c74003c393a&campaign=475960d297da52adfe2f0d28f2bd0307&format=img";

        }

        this.intervalChaturbate = null;
        this.intervalXlovecam = null;

        this.state = {
            chatTurbate : {
                lastUpdate : new Date(),
                isLoading : false,
                data : [],
                page : 1,
                limit : 9,
                totalPage : 0
            },
            xlovecam : {
                lastUpdate : new Date(),
                isLoading : false,
                data : [],
                page : 1,
                limit : 9,
                totalPage : 0
            }
        }
        this.fetchChatTurbate = this.fetchChatTurbate.bind(this);
        this.fetchXlovecam = this.fetchXlovecam.bind(this);
        let bindThis = this;
        this.fetchChatTurbate();
        this.fetchXlovecam();
        this.intervalChaturbate = setInterval(async ()=>{
            await bindThis.fetchChatTurbate()
        }
        ,30000 );
        this.intervalChaturbate = setInterval(async ()=>{
            await bindThis.fetchXlovecam()
        }
        ,30000 );
    }

    componentWillUnmount() {
        clearInterval(this.intervalChaturbate);
        clearInterval(this.intervalXlovecam);

    }

     async fetchChatTurbate() {
        fetchFluxChaturbate().then(response =>{
            let data = response.data || response;
            data = Array.isArray(data) ? data : [];
            if(data.length){
                this.setState({
                    chatTurbate : {
                        ...this.state.chatTurbate,
                        lastUpdate : new Date(),
                        isLoading : true,
                        data : data,
                        totalPage : data.length >0 ? Array.from(Array((data.length / this.state.chatTurbate.limit) - 1).keys()) : 0
                    }
                });
            }
         });
    }

    async fetchXlovecam() {
        fetchFluxXlovecam().then(response =>{
            let data = response.data || response;
            data = Array.isArray(data) ? data : [];
            if(data.length){
                this.setState({
                    xlovecam : {
                        ...this.state.xlovecam,
                        lastUpdate : new Date(),
                        isLoading : true,
                        data : data,
                        totalPage : data.length >0 ? Array.from(Array((data.length / this.state.xlovecam.limit) - 1).keys()) : 0
                    }
                });
            }
        });
    }


    render() {
        return (
            <div id="comparateur-webcam">
                <Helmet>
                    <title>Webcam de Sexe Amateur Gratuit sur Voissa</title>

                    <link rel="canonical" href={canonical(createLink("webcam"))} />
                </Helmet>
                <div className="top-image-bg">
                    <div className="top-image-bg-content">
                        <h1 className="top-image-bg-content-title">Webcam de Sexe Amateur Gratuit sur Voissa</h1>
                        <div className="top-image-bg-content-txt flex">Voissa propose un
                            <Can action={"chat-webcam"} subject="all" passThrough>
                                {can => {
                                    return can ? (
                                        <Link className={"access-messenger"} to={createLink("chatWebcam")}>
                                            <span>chat webcam</span>
                                        </Link>
                                    ) : (
                                        <CtaCannot
                                            action={"chatWebcam"}
                                            isModal={true}
                                            button={
                                                {
                                                    isBtn: false,
                                                    content: "chat webcam",
                                                    className: "m-0"
                                                }
                                            }
                                        />
                                    )
                                }}
                            </Can>
                            pour
                            discuter
                        </div>
                        <div className="top-image-bg-content-txt">entre membre avec sa webcam (non obligatoire)</div>


                    </div>
                </div>

                <div className="comparateur-content">
                    <div className="comparateur-content-bandeau">
                        <img src={pictureBandeau} alt="" />
                            <div className="chaturbate">
                                <h1 className="best-cam">Meilleur portail 2022</h1>
                                <div className="chaturbate-content">
                                    <a href={`${this.urlChaturbate}&spot=logo`} target={"_blank"} rel="noopener noreferrer nofollow"><img className="chaturbate-content-img" src={pictureChaturbate} alt="" /></a>

                                        <ul>
                                            <li><img src={pictureCheck} alt=""/>La plus grosse plateforme de live
                                                gratuit
                                                au
                                                monde
                                            </li>
                                            <li><img src={pictureCheck} alt=""/>Une qualité de webcam et de shows
                                                incroyable
                                            </li>
                                            <li><img src={pictureCheck} alt=""/>Des dizaines de milliers de
                                                spectateurs
                                                en
                                                live
                                            </li>
                                            <li><img src={pictureCrossSmall} alt=""/>Peu de modèles francophones
                                            </li>
                                        </ul>

                                        <div className="ratings-cam">
                                            <h1>4,9</h1>
                                            <div className="star-ratings">
                                                <div className="fill-ratings">
                                                    <span>★★★★★</span>
                                                </div>
                                                <div className="empty-ratings">
                                                    <span>★★★★★</span>
                                                </div>
                                            </div>
                                        </div>

                                </div>

                                    {!this.state.chatTurbate.isLoading ? (
                                        <div className={"p-24"}> <LoadingBar /></div>
                                    ) : (
                                        <div className="chaturbate-profil">
                                            {this.state.chatTurbate.totalPage.length >= 1 && this.state.chatTurbate.totalPage.slice(0, this.state.chatTurbate.page).map((page, indexPage) =>{
                                                let start = this.state.chatTurbate.limit * (page + 1) - this.state.chatTurbate.limit;
                                                if(start >0){
                                                    start++;
                                                }
                                                return (
                                                    <div key={`page_${indexPage}_${this.state.chatTurbate.lastUpdate}`} className="chaturbate-profil-cards">
                                                        {[...this.state.chatTurbate.data].splice(start,this.state.chatTurbate.limit).map((item, index) =>(
                                                            <a key={`${index}_${this.state.chatTurbate.lastUpdate}`} href={`${this.urlChaturbate}&adparameter=${item.slug}&spot=model`} target={"_blank"} rel="noopener noreferrer nofollow" className="chaturbate-profil-cards-card">
                                                                <div className="chaturbate-profil-cards-card-img" style={{ backgroundImage:`url(${item.previewUrl})` }}>
                                                                    <div className="chaturbate-profil-cards-card-img-overlay">
                                                                        <div className="chaturbate-profil-cards-card-img-overlay-online"></div>
                                                                        <div className="chaturbate-profil-cards-card-img-overlay-views">
                                                                            <p>{item.userCount}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <p className="chaturbate-profil-cards-card-profilname">{cropText(item.username,10)}</p>
                                                            </a>
                                                        ))}
                                                    </div>
                                                )
                                            })}
                                            {this.state.chatTurbate.totalPage.length >= 1 && this.state.chatTurbate.page < 9 ? (
                                                <span className="chaturbate-profil-more" onClick={()=> this.setState({chatTurbate : {...this.state.chatTurbate, page : this.state.chatTurbate.page +1}})}>
                                                <svg xmlns="http://www.w3.org/2000/svg"
                                                     version="1.1" width="256" height="256"
                                                     x="0" y="0" viewBox="0 0 24 24"
                                                >
                                                    <g>
                                                        <path
                                                            d="M23.821,11.181v0C22.943,9.261,19.5,3,12,3S1.057,9.261.179,11.181a1.969,1.969,0,0,0,0,1.64C1.057,14.739,4.5,21,12,21s10.943-6.261,11.821-8.181A1.968,1.968,0,0,0,23.821,11.181ZM12,18a6,6,0,1,1,6-6A6.006,6.006,0,0,1,12,18Z"
                                                            fill="#2072ef" data-original="#000000"/>
                                                        <circle cx="12" cy="12" r="4" fill="#2072ef" data-original="#000000"/>
                                                    </g>
                                                </svg>
                                                Voir plus de webcams
                                            </span>
                                            ) : <div className={"p-24"}></div>}

                                        </div>
                                    )}
                            </div>



                            <div className="voissacam">
                                <div className="voissacam-content">
                                    <a href={`${this.urlXlovecam}&spot=logo`} target={"_blank"} rel="noopener noreferrer nofollow"><img className="voissacam-content-img" src={pictureVoissa} alt="" /></a>

                                    <ul>
                                        <li><img src={pictureCheck} alt=""/>Chat gratuit avec des modèles</li>
                                        <li><img src={pictureCheck} alt=""/>Entrez en show privé avec vos
                                            modèles favoris
                                        </li>
                                        <li><img src={pictureCheck} alt=""/>Des modèles françaises
                                        </li>
                                        <li><img src={pictureCrossSmall} alt=""/>Seulement du soft sur le chat
                                            gratuit
                                        </li>
                                    </ul>

                                    <div className="ratings-cam">
                                        <h1>4,8</h1>
                                        <div className="star-ratings">
                                            <div className="fill-ratings">
                                                <span>★★★★★</span>
                                            </div>
                                            <div className="empty-ratings">
                                                <span>★★★★★</span>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                    {!this.state.xlovecam.isLoading ? (
                                        <div className={"p-24"}> <LoadingBar /></div>
                                    ) : (
                                        <div className="voissacam-profil">
                                            {this.state.xlovecam.totalPage.length >= 1 && this.state.xlovecam.totalPage.slice(0, this.state.xlovecam.page).map((page, indexPage) =>{
                                                let start = this.state.xlovecam.limit * (page + 1) - this.state.xlovecam.limit;
                                                if(start >0){
                                                    start++;
                                                }
                                                return (
                                                    <div key={`page_${indexPage}_${this.state.xlovecam.lastUpdate}`} className="voissacam-profil-cards">
                                                        {[...this.state.xlovecam.data].splice(start,this.state.xlovecam.limit).map((item, index) =>(
                                                            <a key={`${index}_${this.state.xlovecam.lastUpdate}`} href={`${this.urlXlovecam}&adparameter=${item.slug}&spot=model`} target={"_blank"} rel="noopener noreferrer nofollow" className="chaturbate-profil-cards-card">
                                                                <div className="voissacam-profil-cards-card-img" style={{ backgroundImage:`url(${item.previewUrl})` }}>
                                                                    <div className="voissacam-profil-cards-card-img-overlay">
                                                                        <div className="voissacam-profil-cards-card-img-overlay-online"></div>
                                                                    </div>
                                                                </div>
                                                                <p className="voissacam-profil-cards-card-profilname">{cropText(item.username,10)}</p>
                                                            </a>
                                                        ))}
                                                    </div>
                                                )
                                            })}
                                            {this.state.xlovecam.totalPage.length >= 1 && this.state.xlovecam.page < 9 ? (
                                                <span className="voissacam-profil-more" onClick={()=> this.setState({xlovecam : {...this.state.xlovecam, page : this.state.xlovecam.page +1}})}>
                                                <svg xmlns="http://www.w3.org/2000/svg"
                                                     version="1.1" width="256" height="256"
                                                     x="0" y="0" viewBox="0 0 24 24"
                                                >
                                                    <g>
                                                        <path
                                                            d="M23.821,11.181v0C22.943,9.261,19.5,3,12,3S1.057,9.261.179,11.181a1.969,1.969,0,0,0,0,1.64C1.057,14.739,4.5,21,12,21s10.943-6.261,11.821-8.181A1.968,1.968,0,0,0,23.821,11.181ZM12,18a6,6,0,1,1,6-6A6.006,6.006,0,0,1,12,18Z"
                                                            fill="#2072ef" data-original="#000000"/>
                                                        <circle cx="12" cy="12" r="4" fill="#2072ef" data-original="#000000"/>
                                                    </g>
                                                </svg>
                                                Voir plus de webcams
                                            </span>
                                            ) : <div className={"p-24"}></div>}

                                        </div>
                                    )}
                            </div>



                            <div className="stripchatcam">
                                <div className="stripchatcam-content">
                                    <a href={this.urlStripchat} target={"_blank"} rel="noopener noreferrer nofollow"><img className="stripchatcam-content-img" src={pictureStripchat} alt="" /></a>

                                        <div className="stripchatcam-content-cta">
                                            <ul>
                                                <li><img src={pictureCheck} alt=""/>Du contenu hard et beaucoup
                                                    d’amatrices
                                                </li>
                                                <li><img src={pictureCheck} alt=""/>Beaucoup de critères, pour tous
                                                    les goûts
                                                </li>
                                                <li><img src={pictureCheck} alt=""/>Des modèles françaises
                                                </li>
                                                <li><img src={pictureCheck} alt=""/>Technologiquement très avancé et
                                                    ergonomique
                                                </li>
                                            </ul>
                                            <div className="stripchatcam-content-cta-btn">
                                                <a href={`${this.urlStripchat}&get=tag-french_girls&spot=tag`} target={"_blank"} rel="noopener noreferrer nofollow">Fille Française</a>
                                                <a href={`${this.urlStripchat}&get=tag-vr_girls&spot=tag`} target={"_blank"} rel="noopener noreferrer nofollow">Cam en VR</a>
                                                <a href={`${this.urlStripchat}&get=tag-interactive_toys&spot=tag`} target={"_blank"} rel="noopener noreferrer nofollow">Jouet interactif</a>
                                            </div>
                                        </div>

                                        <div className="ratings-cam">
                                            <h1>4,7</h1>
                                            <div className="star-ratings">
                                                <div className="fill-ratings">
                                                    <span>★★★★★</span>
                                                </div>
                                                <div className="empty-ratings">
                                                    <span>★★★★★</span>
                                                </div>
                                            </div>
                                        </div>

                                </div>
                            </div>



                            <div className="triple-webcam">
                                <div className="triple-webcam-card">
                                    <a href={`https://tracker.snaping.net/index.php?key=5mwie2rloi33rnx8ujs0&t=&source=${this.source}&spot=logo&site=voissa&adparameter2=livejasmin`} target={"_blank"} rel="noopener noreferrer nofollow" ><img className="triple-webcam-card-img" src={pictureLiveJasmin} alt="" /></a>

                                    <div className="ratings-cam">
                                        <h1>4,6</h1>
                                        <div className="star-ratings">
                                            <div className="fill-ratings">
                                                <span>★★★★★</span>
                                            </div>
                                            <div className="empty-ratings">
                                                <span>★★★★★</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="triple-webcam-card">
                                    <a href={`https://tracker.snaping.net/index.php?key=5mwie2rloi33rnx8ujs0&t=&source=${this.source}&spot=logo&site=voissa&adparameter2=bongacam`} target={"_blank"} rel="noopener noreferrer nofollow" ><img className="triple-webcam-card-img" src={pictureBongacams} alt="" /></a>

                                    <div className="ratings-cam">
                                        <h1>4,5</h1>
                                        <div className="star-ratings">
                                            <div className="fill-ratings">
                                                <span>★★★★★</span>
                                            </div>
                                            <div className="empty-ratings">
                                                <span>★★★★★</span>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <div className="triple-webcam-card">
                                    <a href={`https://tracker.snaping.net/index.php?key=5mwie2rloi33rnx8ujs0&t=&source=${this.source}&spot=logo&site=voissa&adparameter2=myfreecams
`} target={"_blank"} rel="noopener noreferrer nofollow" ><img className="triple-webcam-card-img" src={pictureMyfreecams} alt="" /></a>

                                    <div className="ratings-cam">
                                        <h1>4,4</h1>
                                        <div className="star-ratings">
                                            <div className="fill-ratings">
                                                <span>★★★★★</span>
                                            </div>
                                            <div className="empty-ratings">
                                                <span>★★★★★</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="webcam-text">
                                <p>Il existe des centaines de sites de <strong>webcam sexe</strong> et pourtant tous ne se valent pas. Sur Voissa nous avons décidé de tisser du lien avec les plateformes qui respectent les valeurs de notre communauté, mais aussi les sites ou les camgirls prennent le temps de faire passer du bon temps à ceux qui viennent les voir.</p>
                                <p>Beaucoup de cam-girls sont là pour le plaisir de se montrer, de s'exhiber, d'être vues par des milliers de voyeurs en faisant une <strong>cam sexe</strong> dans leur chambre. C'est cet esprit exhibitionniste et plaisir que nous souhaitons pousser sur Voissa. Bien sur certains services additionnels sont payants (difficile avec le coup de la bande passante de proposer un service à 100% gratuit), mais le fait que des fonctionnalités soient monétisées ne veut pas dire qu'il n'y a pas de qualité. Les webcams gratuites justifient ce côté "freemium" et les Voisssanautes adorent.</p>
                                <h2>Webcam Sexe Amateur : Entrez dans l'intimité des amatrices en direct live</h2>
                                <p>Sur la page la navigation est très simple (et c'est volontaire). A droite un filtre pour les webcams de femmes, de couples, de transsexuels et les cams gratuites d'hommes.</p>
                                <p>Ensuite vous pouvez choisir parmi les nouveaux modèles, celles (ou ceux) qui sont les mieux notées, les cams HD et celles qui ont le plus de votes. Il y a aussi moyen de sélectionner par âge, à savoir si vous aimez les cams de femmes et couples plutôt jeunes ou si ce sont plutôt les femmes cougar et plus matures qui vous rendent fous.</p>
                                <p>Enfin et pour finir, les fétichistes de seins apprécieront clairement de pouvoir choisir parmi les cams de gros, petits ou seins normaux.</p>
                                <p>Prenez de plaisir, la page de <strong>webcam sexe sur Voissa</strong> est avant tout un lieu d'échange 1:1 pour s'amuser :)</p>
                            </div>
                    </div>
                </div>
            <img src={this.urlTracker} width={0} height={0} alt={""} />
            </div>
        )
    }
}


const mapStateToProps = state => ({

});


const mapDispatchToProps = (dispatch) => bindActionCreators({

}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ComparatorWebcam);


